import { styled } from '@mui/material/styles';

import { NavigationItemWrapper as DefaultNavigationItemWrapper } from 'applications/GSP/layouts/MainLayout/components/Sidebar/components/components/NavigationItem';
import { SidebarStateKey } from 'applications/GSP/layouts/MainLayout/components/Sidebar/store';

import {
  openedListItemMixin,
  closedListItemMixin,
  getBackgroundColor,
} from './utils';

import type {
  SidebarAnimatedComponentsState,
  NavigationItem,
} from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

type NavigationItemWrapperState = SidebarAnimatedComponentsState &
  Pick<NavigationItem, 'disabled' | 'sidebarType'>;

export const NavigationItemWrapper = styled(DefaultNavigationItemWrapper, {
  shouldForwardProp: prop => prop !== SidebarStateKey.Opened,
})<NavigationItemWrapperState>(({ theme, opened, disabled, sidebarType }) => ({
  pointerEvents: disabled ? 'none' : 'auto',
  padding: opened ? theme.spacing(0.5, 1) : theme.spacing(1.5),

  '&.active': {
    backgroundColor: getBackgroundColor({ theme, opened, sidebarType }),
  },
  ...(opened && {
    ...openedListItemMixin(theme),
  }),
  ...(!opened && {
    ...closedListItemMixin(theme),
  }),
}));
